/**
 * AppLogo - Responsive brand logo
 *
 * Design System Layer 2: LetsGetHome logo with responsive switching
 * - Mobile: Square mark (logo-mark-square-color.svg)
 * - Desktop: Horizontal logo (logo-horizontal-color.webp)
 *
 * Uses next/image for automatic optimization.
 * CSS handles visibility switching (not <picture> tag).
 *
 * Matches Rails: layouts/nav/_company_logo.html.erb
 */

import Image from '@/shared/components/ui/Image';
import { BRAND_NAME } from '@letsgethome/lib/constants';
import { assetPath, plainText } from '@letsgethome/types/branded';
import { cn } from '@letsgethome/ui/lib/utils';

export interface AppLogoProps {
  /** Additional classes for the container */
  className?: string;
}

export function AppLogo({ className }: AppLogoProps) {
  return (
    <div className={cn('flex items-center', className)}>
      {/* Mobile: Square mark - visible on small screens */}
      <Image
        src={assetPath('/brand/logo-mark-square-color.svg')}
        alt={plainText(BRAND_NAME)}
        width={40}
        height={40}
        className="block md:hidden"
        priority
        unoptimized
      />
      {/* Desktop: Horizontal logo - visible on md+ screens */}
      <Image
        src={assetPath('/brand/logo-horizontal-color.webp')}
        alt={plainText(BRAND_NAME)}
        width={150}
        height={46}
        className="hidden md:block h-10 w-auto"
        priority
        unoptimized
      />
    </div>
  );
}
